'use client'

import { setCookie } from 'cookies-next'
import { useCallback, useEffect, useState } from 'react'

import { View, VIEW_COOKIE } from '@/shared/config'

const QUERY = '(min-width: 768px)'

type Props = {
  defaultValue?: View
}

export const useView = ({ defaultValue }: Props = {}) => {
  const [view, setView] = useState<View | null>(defaultValue ?? null)

  const updateView = useCallback((view: View) => {
    setView(view)
    void setCookie(VIEW_COOKIE, view)
  }, [])

  useEffect(() => {
    const mediaQuery = window.matchMedia(QUERY)

    const initialView = mediaQuery.matches ? View.Desktop : View.Mobile
    updateView(initialView)

    const handleChange = (event: MediaQueryListEvent) => {
      const updatedView = event.matches ? View.Desktop : View.Mobile
      updateView(updatedView)
    }

    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [updateView])

  return view
}
